import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const skeletonStyle={bgcolor: 'rgba(255,255,255, 0.2)'};

export const LoadingStack = () => {
    return (
      <Stack spacing={1} sx={{marginTop: '50px'}}>
        <Skeleton variant="rounded" width={'100%'} height={30} sx={skeletonStyle}/>
        <Skeleton variant="rounded" width={'100%'} height={30} sx={skeletonStyle} animation="wave"/>
        <Skeleton variant="rounded" width={'100%'} height={30} sx={skeletonStyle}/>
      </Stack>
    );
};
  